// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const domainCreditsListDto = {
    domainGuid: 'domainGuid',
    domainAUserGuid: 'domainAUserGuid',
    name: 'name',
    isOwner: 'isOwner',
    creditBalance: 'creditBalance',
    creditLimit: 'creditLimit',
    billingState: 'billingState',
    archived: 'archived',
} as const;

export type TDomainCreditsListDto = (typeof domainCreditsListDto)[keyof typeof domainCreditsListDto];

export interface IDomainCreditsListDto {
    [domainCreditsListDto.domainGuid]: string | null;
    [domainCreditsListDto.domainAUserGuid]: string | null;
    [domainCreditsListDto.name]: string | null;
    [domainCreditsListDto.isOwner]: boolean | null;
    [domainCreditsListDto.creditBalance]: number | null;
    [domainCreditsListDto.creditLimit]: number | null;
    [domainCreditsListDto.billingState]: string | null;
    [domainCreditsListDto.archived]: boolean | null;
}

export class DomainCreditsListDto
    implements IDomainCreditsListDto
{
    [domainCreditsListDto.domainGuid]: string | null = null;
    [domainCreditsListDto.domainAUserGuid]: string | null = null;
    [domainCreditsListDto.name]: string | null = null;
    [domainCreditsListDto.isOwner]: boolean | null = null;
    [domainCreditsListDto.creditBalance]: number | null = null;
    [domainCreditsListDto.creditLimit]: number | null = null;
    [domainCreditsListDto.billingState]: string | null = null;
    [domainCreditsListDto.archived]: boolean | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IDomainCreditsListData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[domainCreditsListDto.guid] = modelData[domaincreditslistData.guid];
    }

    static create(modelData?: any | null): IDomainCreditsListDto | null {
        return modelData ? new DomainCreditsListDto(modelData) : null;
    }
}
